import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AdminLayout } from "@/components/AdminLayout";
import { api, errText } from "@/lib/api";
import { StatCards, FunnelBars, DailyChart, CampaignTable, DailyTable } from "@/components/analytics/FunnelWidgets";
import { toast } from "sonner";

const RANGES = [7, 30, 90];

export default function FunnelAnalytics() {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get("/analytics/funnel", { params: { days } }).then((r) => setData(r.data)).catch((e) => toast.error(errText(e)));
  }, [days]);

  const q = data?.lead_breakdown?.by_qualification || {};

  return (
    <AdminLayout title="Landing Page Analytics">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8 -mt-2">
        <p className="text-sm text-gray-500">
          Visitors are counted once per browser session. {data && <span data-testid="range-label">{data.start} → {data.end} · Toronto time</span>}
        </p>
        <div className="flex border border-gray-300 bg-white" data-testid="range-picker">
          {RANGES.map((r) => (
            <button
              key={r}
              data-testid={`range-${r}`}
              onClick={() => setDays(r)}
              className={`h-10 px-4 text-[11px] uppercase tracking-wider font-semibold transition-colors duration-150 ${days === r ? "bg-black text-white" : "text-gray-600 hover:bg-gray-50"}`}
            >
              Last {r} days
            </button>
          ))}
        </div>
      </div>

      {!data ? (
        <p className="text-gray-400">Loading...</p>
      ) : (
        <div className="space-y-6" data-testid="funnel-analytics">
          <StatCards totals={data.totals} />
          <div className="grid lg:grid-cols-3 gap-6 items-start">
            <div className="lg:col-span-2 min-w-0"><DailyChart byDay={data.by_day} /></div>
            <div className="space-y-6 min-w-0">
              <FunnelBars totals={data.totals} />
              <div className="bg-white border border-gray-200 p-6" data-testid="lead-breakdown">
                <div className="flex items-baseline justify-between mb-4">
                  <p className="text-[11px] uppercase tracking-[0.18em] text-gray-500">Lead quality</p>
                  <Link to="/admin/leads" className="text-[11px] uppercase tracking-[0.14em] text-[#8a6a42] hover:text-black underline underline-offset-4">Open leads</Link>
                </div>
                {Object.keys(q).length === 0 ? (
                  <p className="text-sm text-gray-400">No leads in this period.</p>
                ) : (
                  <div className="space-y-2">
                    {Object.entries(q).sort((a, b) => b[1] - a[1]).map(([k, n]) => (
                      <div key={k} className="flex justify-between text-sm border-b border-gray-100 pb-2 last:border-0">
                        <span className="text-gray-600">{k}</span><span className="font-semibold">{n}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          <CampaignTable campaigns={data.by_campaign} />
          <DailyTable byDay={data.by_day} />
        </div>
      )}
    </AdminLayout>
  );
}
